import React from 'react';
import {
  Form,
  Input,
  Radio,
  Select,
  DatePicker,
  Button,
  Typography,
  Row,
  Col,
  Space,
  Tabs,
} from 'antd';
import OutOnWorkForm from './OutOnWork';

const { Title, Text, Link } = Typography;
const { Option } = Select;

const AttendenceTab = () => {

    const items = [
  {
    key: '1',
    label: 'Create an Out-on-Work Request',
    children: <OutOnWorkForm />
  },
  {
    key: '2',
    label: 'Mark Past Attendance',
    children: 'sdaf',
  },
  {
    key: '3',
    label: 'Team Attendance Summary',
    children: 'Content of Tab Pane 3',
  },
  {
    key: '4',
    label: 'Past Attendance Requests',
    children: 'Content of Tab Pane 3',
  },
  {
    key: '5',
    label: 'Daily Attendance Report',
    children: 'Content of Tab Pane 3',
  },
   {
    key: '6',
    label: 'Reports',
    children: 'Content of Tab Pane 3',
  },
];
  const [form] = Form.useForm();
const onChange = key => {
  console.log(key);
};
  return (
    <div className='inner-tab'>
       <Tabs className='tabs' defaultActiveKey="1" items={items} onChange={onChange} />

    
    </div>
    
  );
};

export default AttendenceTab;
